/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_LabelInputs */

const en_us2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminder time`)
};

const pt_br2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horário do lembrete`)
};

const es_419_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora del recordatorio`)
};

const pt_pt2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora do lembrete`)
};

const fr_fr2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure du rappel`)
};

const de_de2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit der Erinnerung`)
};

const it_it2_profile_editors_reminder_label = /** @type {(inputs: Profile_Editors_Reminder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orario del promemoria`)
};

/**
* | output |
* | --- |
* | "Reminder time" |
*
* @param {Profile_Editors_Reminder_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_label = /** @type {((inputs?: Profile_Editors_Reminder_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_label(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_label(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_label(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_label(inputs)
	return en_us2_profile_editors_reminder_label(inputs)
});
export { profile_editors_reminder_label as "profile-editors.reminder_label" }